module.exports = __webpack_public_path__ + "img/+_cn.af5da45d.svg";